const Document = () => {
  return (
    <div>Document</div>
  )
}

export default Document